import React from "react";

const HorizontalRule = () => <hr className='hr-web-sdk' />;

export default HorizontalRule;
